import { useQuery } from '@tanstack/react-query';

import {
  MAXIMUM_GAS_ACCOUNT_BALANCE,
  MINIMUM_GAS_ACCOUNT_TOPUP,
  type GetGasQuoteInput,
} from '@infinex/main-service-contract/v2/client/gas';

import { getTRPCClient } from '../config';

export function useGasDepositQuote(
  args: Omit<GetGasQuoteInput, 'userWalletId'> &
    Partial<Pick<GetGasQuoteInput, 'userWalletId'>>
) {
  const trpc = getTRPCClient();
  const custody = args.custody ?? 'wallet';
  const hasValidSource =
    args.topUpType === 'jit_top_up' ||
    custody === 'vault' ||
    (custody === 'wallet' && Boolean(args.userWalletId));

  return useQuery(
    trpc.gas.getGasDepositQuote.queryOptions(
      {
        ...args,
        userWalletId: args.userWalletId,
        custody,
      },
      {
        enabled:
          hasValidSource &&
          args.gasAmount >= MINIMUM_GAS_ACCOUNT_TOPUP &&
          args.gasAmount <= MAXIMUM_GAS_ACCOUNT_BALANCE,

        staleTime: 25 * 1000, // 25 seconds
      }
    )
  );
}
